import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { api } from '../../Constant';
import { useParams, useNavigate } from 'react-router-dom';
import lovebg from "../../assets/images/love-bg.png";

const SubCategory = () => {
  const { category_id } = useParams();
  const navigate = useNavigate();

  const [subcategories, setSubcategories] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [loading, setLoading] = useState(false); // Loader state

  useEffect(() => {
    if (!category_id) return;

    setLoading(true); // Start loader

    axios
      .post(api + 'subcategory_list', { category_id })
      .then((res) => {
        if (res.data.success === "true") {
          setCategoryName(res.data.category_name || '');
          setSubcategories(res.data.Subcategory || []);
        } else {
          setSubcategories([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching subcategories:", err);
        setSubcategories([]);
      })
      .finally(() => {
        setLoading(false); // Stop loader
      });
  }, [category_id]);

  const handleShopNow = (subcategory_id) => {
    navigate(`/subcategory-detail/${subcategory_id}`);
  };

  return (
    <div className="caytegory-bg pt-5 pb-5">
      <div className="container">
        {loading ? (
          // Preloader
          <div className="text-center my-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <h2 className="mb-4">{categoryName}</h2>
            <div className="row category-main-top">
           {subcategories.map((item) => (
  <div className="col-lg-3 col-sm-6 maincategory" key={item.subcategory_id}>
    <div
      className="category-card"
      style={{
        backgroundImage: `url(${lovebg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        borderRadius: '10px',
        padding: '15px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <img
        src={item.subcategory_image}
        alt={item.subcategory_name}
        style={{
          width: '100%',
          borderRadius: '10px',
          objectFit: 'cover',
        }}
      />
    </div>

    <div className="category-cardbottom">
      <p>{item.subcategory_name}</p>
    </div>

    <div
      className="category-cardbottomone"
      onClick={() => handleShopNow(item.subcategory_id)}
    >
      <a>Shop now</a>
    </div>
  </div>
))}
              {subcategories.length === 0 && (
                <p>No subcategories available for this category.</p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SubCategory;
